module.exports = __webpack_public_path__ + "img/user-default.6f33d731.svg";